<template>
    <div class="auctionDetail">
        <div class="detail_box">
            <div class="details">
                <div class="details_name">{{ details.name }}</div>
                <div class="details_wrapper">
                    <div class="left">
                        <div class="swiper-container gallery-top">
                            <div class="swiper-wrapper" style="cursor: pointer">
                                <div class="swiper-slide" v-for="(item,index) in pics" :key="index">
                                    <img class="img" :src="item" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="smallImg">
                            <!--<span class="iconfont left-arrow">&#xe609;</span>-->
                            <div class="swiper-container gallery-thumbs">
                                <ul class="swiper-wrapper">
                                    <li class="swiper-slide" v-for="(item,index) in pics" :key="index">
                                        <img class="img" :src="item" alt="">
                                    </li>
                                </ul>
                            </div>
                            <!--<span class="iconfont right-arrow">&#xe60a;</span>-->
                        </div>
                        <div class="vr_video">
                            <div class="vr_btn vv_btn" @click="toShowVR"
                                 v-if="details.url_vr !== '' && details.url_vr !== null">
                                <!--<a :href="details.url_vr" target="_blank">VR</a>-->
                                <a>VR</a>
                            </div>
                            <div class="vv_btn" @click="toShowVideo"
                                 v-if="details.url_video !== '' && details.url_video !== null">
                                <!--<a :href="details.url_video" target="_blank">视频</a>-->
                                <a>视频</a>
                            </div>
                        </div>
                    </div>
                    <div class="right">
                        <div class="right_top">
                            <div class="timePriceLeft">
                                <div class="time_price" v-if="details.status === 2">
                                    <div class="time_tip">开拍时间</div>
                                    <div class="time_price_con">
                                        {{ details.time_start == null? '-':details.time_start }}
                                    </div>
                                </div>
                                <div class="time_price" v-else>
                                    <div class="time_tip">结束时间</div>
                                    <div class="time_price_con">
                                        {{ details.time_end == null? '—' :details.time_end }}
                                    </div>
                                </div>
                                <div class="ren_price">
                                    <div class="time_price"
                                         v-if="details.status === 2 && (details.price_cur != null && details.price_cur !== '0')">
                                        <div class="time_tip">起拍价</div>
                                        <div class="time_price_con">
                                            <div class="price_cur">
                                                {{ details.price_cur }}
                                            </div>
                                        </div>
                                        <div class="time_tip">元</div>
                                    </div>
                                    <div class="time_price"
                                         v-else-if="details.status === 3 && !isEndPrice && (details.price_cur != null  && details.price_cur !== '0')">
                                        <div class="time_tip">成交价</div>
                                        <div class="time_price_con">
                                            <div class="price_cur">{{ details.price_cur }}</div>
                                        </div>
                                        <div class="time_tip">元</div>
                                    </div>
                                    <div class="time_price" v-else
                                         v-show="details.price_cur != null  && details.price_cur !== '0'">
                                        <div class="time_tip">当前价</div>
                                        <div class="time_price_con">
                                            <div class="price_cur">{{ details.price_cur }}</div>
                                        </div>
                                        <div class="time_tip">元</div>
                                    </div>
                                    <div class="time_price">
                                        <div class="time_tip">出价人</div>
                                        <div class="time_price_con">
                                            {{details.user_id}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="timePriceRight" @click="noticChg()" v-show="isNOtice === 0">
                                <i class="iconfont icon-naozhong">&#xe806;</i>
                                <div>
                                    订阅提醒
                                </div>
                            </div>
                            <div class="timePriceRight" @click="noticChg()" v-show="isNOtice === 1">
                                <i class="iconfont icon-naozhong">&#xe806;</i>
                                <div>
                                    取消订阅
                                </div>
                            </div>
                        </div>
                        <div class="apply_box">
                            <div class="apply_top" v-show="details.status === 1">
                                <div class="apply_price">出价</div>
                                <div class="operation">
                                    <!--<img @click="toAdd" class="add operation_img"-->
                                    <!--src="../../assets/images/auctionDetail/add.png" alt="">-->
                                    <img @click="subtract" class="operation_img"
                                         src="../../assets/images/auctionDetail/substract.png" alt="">
                                </div>
                                <input class="price_input" type="text" v-model="price" placeholder="出价金额"
                                       @input="toInputPrice()">
                                <div class="operation">
                                    <img @click="toAdd" class="add operation_img"
                                         src="../../assets/images/auctionDetail/add.png" alt="">
                                    <!--<img @click="subtract" class="operation_img"-->
                                    <!--src="../../assets/images/auctionDetail/substract.png" alt="">-->
                                </div>
                            </div>
                            <div class="apply_btn">
                                <button class="btn"
                                        v-show="noLogin === '0' && (details.status === 1 || details.status === 2)"
                                        @click='$router.push("/login")'>
                                    去登录
                                </button>
                                <button class="btn"
                                        v-show="needApply && (details.status === 1 || details.status === 2)">
                                    <el-popover
                                            placement="top-start"
                                            title=""
                                            width="200"
                                            trigger="hover">
                                        <div class="tip" v-if="notice != null">
                                            <div v-for="(item,index) in notice.split('\n')" :key="index">
                                                {{item}}
                                            </div>
                                        </div>
                                        <div slot="reference">去报名</div>
                                    </el-popover>
                                </button>
                                <el-button class="btn" v-show="tobin && details.status === 1" @click="toShowApply">立即出价
                                </el-button>
                                <el-button class="startBtn"
                                           v-show="details.status === 2 && tobin"
                                           type="info" disabled>{{ details.status_des }}
                                </el-button>
                                <el-button class="endBtn"
                                           v-show="details.status === 3 || details.status === 4 || details.status === 5"
                                           type="info" disabled>{{ details.status_des }}
                                </el-button>
                                <!--<div class="must_see">报名必看>></div>-->
                            </div>
                            <!--<div class="apply_tip" v-show="needApply && (details.status === 1 || details.status === 2)">-->
                            <!--<img class="bell" src="../../assets/images/auctionDetail/bell.png" alt="">-->
                            <!--<div class="tip" >-->
                            <!--<div v-for="item in notice.split('\n')">-->
                            <!--{{item}}-->
                            <!--</div>-->
                            <!--</div>-->
                            <!--</div>-->
                            <div class="apply_tip"
                                 v-show="details.price_cur === parseInt(myRecordInfo.me_price).toLocaleString() && details.status === 1">
                                <img class="bell" src="../../assets/images/auctionDetail/bell.png" alt="">
                                <div>您当前已处于领先状态</div>
                            </div>
                            <div class="myInfo"
                                 v-show="tobin && (details.status === 1 || details.status === 2) && noLogin === '1' ">
                                <div class="myInfo_item">
                                    我的竞拍号
                                    <div class="info_con">{{ myInfo.u_id }}</div>
                                </div>
                                <div class="myInfo_item">
                                    用户名
                                    <div class="info_con">{{ myInfo.name }}</div>
                                </div>
                                <div class="myInfo_item">
                                    已出价
                                    <div class="info_con">{{ myRecordInfo.count }}次</div>
                                </div>
                            </div>
                            <div class="center_right" v-show="details.status === 1">
                                正在进行
                            </div>
                            <div class="center_right center_start" v-show="details.status === 2">
                                即将开始
                            </div>
                            <!--<div class="center_right center_end"-->
                            <!--v-show="details.status === 3 || details.status === 4 || details.status === 5">-->
                            <!--{{ details.status_des }}-->
                            <!--</div>-->
                        </div>
                        <div class="json_box">
                            <div class="json_left">
                                <div>
                                    {{ details.number_view }}次围观
                                </div>
                                <div class="json_img">
                                    <img src="../../assets/images/auction/view.png" alt="">
                                </div>

                            </div>
                            <div class="json_right">
                                <div>
                                    {{ details.number_join }}人报名
                                </div>
                                <div class="json_img">
                                    <img src="../../assets/images/auction/apply.png" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="other">
                            <div class="other_item"
                                 v-show="details.price_start != null  && details.price_start !== '0'">
                                起拍价：￥{{ details.price_start }}
                            </div>
                            <div class="other_item" v-show="details.price_inc != null  && details.price_inc !== '0'">
                                加价幅度：￥{{ details.price_inc }}
                            </div>
                            <div class="other_item" v-show="details.price_guess != null && details.price_guess !== '0'">
                                评估价：￥{{ details.price_guess
                                }}
                            </div>
                            <div class="other_item" v-show="details.price_min != null  && details.price_min !== '0'">
                                保留价：￥{{ details.price_min }}
                            </div>
                            <div class="other_item" v-show="details.price_max != null  && details.price_max !== '0'">
                                封顶价：￥{{ details.price_max }}
                            </div>
                            <div class="other_item" v-show="details.price_hold != null  && details.price_hold !== '0'">
                                保证金：￥{{ details.price_hold }}
                            </div>
                            <div class="other_item pointer">
                                <el-popover
                                        placement="top-start"
                                        title=""
                                        width="200"
                                        trigger="hover"
                                        :content='time_delay_tip'>
                                    <div slot="reference">延时周期：{{ details.time_delay }}分钟 <i
                                            class="el-icon-question"></i>
                                    </div>
                                </el-popover>
                            </div>
                            <div class="other_item">支付方式：线下支付</div>
                        </div>
                        <div class="rules">
                            竞拍规则：至少一人报名且出价不低于起拍价，方可成交
                        </div>
                        <div class="rules pointer" id='geo' @click="openAmap()">
                            {{category_type === 0?'竞拍地址':'竞租地址'}}：{{ details.address }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="flows_box">
                <div class="flows">
                    <div class="flows_left">
                        竞拍流程
                    </div>
                    <div class="flows_right">
                        <div class="flow" v-for="(item,index) in flowList" :key="index">
                            <img class="flow_arrow" src="../../assets/images/auction/flow_arrow.png" alt="">
                            <div class="flow_box">
                                <div class="flow_img">
                                    <img class="flow_item_img" :src="item.logo" alt="">
                                </div>
                                <div class="flow_title">
                                    {{ item.title }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab_box">
                <div class="tab">
                    <div class="tab_item" :class="{active:tab === 1}" @click="changeTab(1)">
                        重要提示
                    </div>
                    <div class="tab_item" :class="{active:tab === 2}" @click="changeTab(2)">
                        {{category_type === 0?'竞拍公告':'竞租公告'}}
                    </div>
                    <div class="tab_item" :class="{active:tab === 3}" @click="changeTab(3)">
                        {{category_type === 0?'竞拍须知':'竞租须知'}}
                    </div>
                    <div class="tab_item" :class="{active:tab === 4}" @click="changeTab(4)">
                        标的物介绍
                    </div>
                    <div class="tab_item" :class="{active:tab === 5}" @click="changeTab(5)">
                        {{category_type === 0?'竞拍记录':'竞租记录'}}
                    </div>
					<div class="tab_item" :class="{active:tab === 6}" @click="changeTab(6)" v-if="isShowTab">
                        成交确认书
                    </div>
                </div>
            </div>
            <div class="tab_con">
                <!--<div v-html="content" v-show="tab !== 5"></div>-->
                <div v-if="content != null && tab !== 5">
                    <div v-html="item" v-for="(item,index) in content.split('\n')" :key='index'></div>
                </div>
                <div class="originMapBox" v-show="tab === 4 && this.details.lat_origin !== ''">
					
					<div id="originMap">
                       
                    </div>
					<div class="resetOriMap pointer" @click="originMap()">
                            重置地图
                        </div>
                </div>
                <el-table v-show="tab === 5"
                          :data="recordList"
                          stripe
                          :row-class-name="firstRowClass"
                          style="width: 100%">
                    <el-table-column
                            label="状态"
                            min-width="180">
                        <template slot-scope="scope">
                            <div>
                                {{ (scope.row.id === recordList[0].id && page === 1)?"领先" : '出局'}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="user_name"
                            label="竞拍号"
                            min-width="180">
                    </el-table-column>
                    <el-table-column
                            label="出价"
                            min-width="180">
                        <template slot-scope="scope">
                            <div>
                                ￥{{ parseInt(scope.row.price).toLocaleString()}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="create_time"
                            label="出价时间"
                            min-width="180">
                    </el-table-column>
                </el-table>
                <el-pagination
                        v-show="tab === 5 && recordList.length !== 0"
                        background
                        @current-change="handleCurrentChange"
                        :current-page.sync="page"
                        :page-size="limit"
                        layout="total, prev, pager, next"
                        :total="total">
                </el-pagination>
            </div>
            <!--竞拍地图-->
            <div v-show="isOpenAmap" class="amap-box">
                <div class="amap_content">
                    <div id="container"></div>
                    <div>
                        <div class="close pointer" @click="closeAmap()">
                            <i class="iconfont" title="关闭">&#xe617;</i>
                        </div>
                        <div class="resetMap pointer" @click="openAmap">
                            重置
                        </div>
                    </div>
                </div>
            </div>
            <div class="ShowVR" v-show="ShowVR">
                <iframe class="VR" id="nb-iframe" :src="VRUrl" frameborder="0"></iframe>
                <div class="exit" @click="closeVR">
                    退出
                </div>
            </div>
            <div class="ShowVideo" v-show="ShowVideo">
                <video autoplay :src="videoUrl" id="video" controls="controls"></video>
                <div class="exit" @click="closeVideo">
                    退出
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
	import Swiper from 'swiper';
	import 'swiper/css/swiper.css';
	// import downTime from '../../components/downTime'
	// import {isLogin} from "../../api";
	import {
		goodsDetail, record, flows, viewReport, checkPaimai, about, commitRecord, record_info, notice_chg, check_notice
	} from "../../apiNew/index";

	export default {
		name: '',
		data() {
			return {
				details: {},
				recordList: [],// 竞拍记录
				rowIndex: '',
				tab: 1,
				callPhone: '',
				// type: '',
				category_type: 0,
				title: '',
				content: '',
				page: 1,
				limit: 10,
				total: 0,
				show: false,
				notice: '',
				pics: [],
				noLogin: '0', // 未登录
				needApply: false, // 有竞拍权限
				tobin: false,// 立即出价
				nowTime: '',// 当前时间
				hasEnd: false,
				price: '0',
				flowList: [],
				myInfo: '',//
				myRecordInfo: '',
				ShowVideo: false,// 是否播放视频
				videoUrl: '',
				detailsId: '',
				categoryId: '',
				token: '',
				isEndPrice: false,
				isOpenAmap: false,
				lat: '',
				lon: '',
				lat_origin: '',
				lon_origin: '',
				location: require('../../assets/images/location.png'),
				VRUrl: '',
				ShowVR: false,
				isNOtice: 0,
				time_delay_tip: '', // 延迟周期提示
			}
		},
		components: {},
		created() {
			var that = this
			// this.detailsId = window.location.pathname.split('/')[3]
			// console.log(window.location.pathname.split('/')[1])
			this.category_type = Number(window.location.pathname.split('/')[2])
			this.detailsId = Number(window.location.pathname.split('/')[3])

			// if (localStorage.getItem('categoryId') != null) {
			// 	this.categoryId = Number(localStorage.getItem('categoryId'))
			// }
			if (localStorage.getItem('token') != null) {
				this.token = localStorage.getItem('token')
			}
			if (localStorage.getItem('isLogin') === '1') {
				this.noLogin = localStorage.getItem('isLogin')
			}
			if (localStorage.getItem('userInfo') != null) {
				this.myInfo = JSON.parse(localStorage.getItem('userInfo'))
			}
			that.hasLogin();
			// console.log(localStorage.getItem('categoryId'))
			window.addEventListener('setItemEvent', function (e) {
				// console.log(e)
				// // this.category_type = Number(window.location.pathname.split('/')[2])
				if (e.key === 'isLogin') {
					// 	console.log(e.newValue)
					that.noLogin = e.newValue
					if (e.newValue === '0') {
						localStorage.removeItem('token');
						localStorage.removeItem('userInfo');
					}
				}
				if (e.key === 'token') {
					// console.log(e.newValue)
					that.token = e.newValue
				}
				if (e.key === 'userInfo') {
					// console.log(e.key, JSON.parse(e.newValue))
					that.myInfo = JSON.parse(e.newValue)
				}
				// console.log(that.noLogin === '1' && (that.token != null || that.token !== '')
				// 	&& (that.myInfo != null || that.token !== ''))
				if (that.noLogin === '1') {
					that.hasLogin()
				}
			})
			// window.addEventListener('setItemEvent', function (e) {
			// 	// console.log(e)
			// 	if (e.key === 'isLogin') {
			// 		that.noLogin = localStorage.getItem('isLogin')
			// 	} else if (e.key === 'userInfo') {
			// 		that.userInfo = JSON.parse(e.newValue)
			// 	} else if (e.key === 'token') {
			// 		that.token = JSON.parse(e.newValue)
			// 	}
			// 	// that.docData.hasLogin = localStorage.getItem('isLogin')
			// 	// that.userInfo = JSON.parse(localStorage.getItem('userInfo'))
			// })
		},
		mounted() {
			// console.log(downTime.methods.setTime())
			this.nowTime = new Date().getTime();
			let that = this;
			that.detail();
			that.getPhone();
			this.timer = setInterval(() => {
				goodsDetail({
					// id: localStorage.getItem('auctionId')
					id: this.detailsId,
				}).then(res => {
					if (res.data.price_cur === res.data.price_start) {
						this.isEndPrice = true
					} else {
						this.isEndPrice = false
					}
					// console.log(res)
					that.details.number_view = parseInt(res.data.number_view).toLocaleString()
					that.details.number_join = parseInt(res.data.number_join).toLocaleString()
					// that.details.price_start = parseInt(res.data.price_start).toLocaleString()
					that.details.price_cur = parseInt(res.data.price_cur).toLocaleString()
					that.details.price_min = parseInt(res.data.price_min).toLocaleString()
					that.details.price_max = parseInt(res.data.price_max).toLocaleString()
					that.details.time_end = res.data.time_end
					that.details.user_id = res.data.user_id
					// const price_start = parseInt(this.details.price_start.replace(/,/gi, ''))
					// const price_cur = parseInt(this.details.price_cur.replace(/,/gi, ''))
					// const price_inc = parseInt(this.details.price_inc.replace(/,/gi, ''))
					// console.log(price_cur)
					// if (price_cur === 0 || price_cur == null || price_cur === '' || res.data.user_id === '-') {
					// 	this.price = this.details.price_start
					// 	// } else if (price_cur === price_start) {
					// 	// 	this.price = price_start.toLocaleString()
					// } else {
					// 	this.price = (price_cur + price_inc).toLocaleString()
					// }
					this.$nextTick(() => {
						that.List()
					});
				}).catch(error => {
					this.$message({
						message: error.message,
						type: "error"
					});
				})
			}, 3000);
			// console.log(this.detailsId, this.noLogin, this.needApply)
		},
		computed: {
			isShowTab(tabIndex) {
				let result = false
				if (this.details.imgUrlOfAuctionConfirm) {
					result = true
				}
				return result
			}
		},
		methods: {
			// 竞拍、竞租地图
			openAmap() {
				if (this.details.lat !== '' && this.details.lat != null) {
					document.documentElement.style.overflow = "hidden";
					document.documentElement.style.height = "100%";
					document.body.style.overflow = "hidden";
					document.body.style.height = "100%";
					const that = this;
					that.isOpenAmap = true
					const AMap = window.AMap

					that.lat = that.details.lat // 竞拍纬度
					that.lon = that.details.lon // 经度
					console.log(that.lat)
					// that.lat_origin = that.details.lat_origin // 标的物纬度
					// that.lon_origin = that.details.lon_origin // 经度
					var map = new AMap.Map('container', {
						resizeEnable: true, //是否监控地图容器尺寸变化
						zoom: 15, //初始化地图层级
						center: [that.lon, that.lat] //初始化地图中心点
					});

					// 创建一个 Icon
					var startIcon = new AMap.Icon({
						// 图标尺寸
						size: new AMap.Size(25, 34),
						// 图标的取图地址
						image: that.location,
						// 图标所用图片大小
						imageSize: new AMap.Size(25, 32),
						// 图标取图偏移量
						// imageOffset: new AMap.Pixel(-9, -3)
					});


					// 将 icon 传入 marker
					var startMarker = new AMap.Marker({
						position: new AMap.LngLat(that.lon, that.lat),
						icon: startIcon,
						offset: new AMap.Pixel(-13, -30)
					});
					// 设置鼠标划过点标记显示的文字提示
					startMarker.setTitle('竞拍地址');

					// 设置label标签
					// label默认蓝框白底左上角显示，样式className为：amap-marker-label
					startMarker.setLabel({
						offset: new AMap.Pixel(0, 0),  //设置文本标注偏移量
						content: "<div class='info'>竞拍地址</div>", //设置文本标注内容
						direction: 'top' //设置文本标注方位
					});
					map.add([startMarker]);
				} else {
					this.toGeoCode()
				}
			},
			// 标的物地图
			originMap() {
				if (this.details.lat_origin !== '' && this.details.lat_origin != null) {
					const that = this;
					const AMap = window.AMap
					that.lat_origin = that.details.lat_origin // 标的物纬度
					that.lon_origin = that.details.lon_origin// 经度
					console.log(that.lat_origin)
					var map = new AMap.Map('originMap', {
						resizeEnable: true, //是否监控地图容器尺寸变化
						zoom: 15, //初始化地图层级
						center: [that.lon_origin, that.lat_origin] //初始化地图中心点
					});

					// 创建一个 Icon
					var endIcon = new AMap.Icon({
						// 图标尺寸
						size: new AMap.Size(25, 34),
						// 图标的取图地址
						image: that.location,
						// 图标所用图片大小
						imageSize: new AMap.Size(25, 32),
						// 图标取图偏移量
						// imageOffset: new AMap.Pixel(-9, -3)
					});

					// 将 icon 传入 marker
					var endMarker = new AMap.Marker({
						position: new AMap.LngLat(that.lon_origin, that.lat_origin),
						icon: endIcon,
						offset: new AMap.Pixel(-13, -30)
					});
					// 设置鼠标划过点标记显示的文字提示
					endMarker.setTitle('标的物所在地址');

					// 设置label标签
					// label默认蓝框白底左上角显示，样式className为：amap-marker-label
					endMarker.setLabel({
						offset: new AMap.Pixel(0, 0),  //设置文本标注偏移量
						content: "<div class='info'>标的物所在地址</div>", //设置文本标注内容
						direction: 'top' //设置文本标注方位
					});
					map.add([endMarker]);
				}
			},
			toGeoCode() {
				const that = this;
				const AMap = window.AMap
				const geocoder = new AMap.Geocoder({
					// city: "010", // 城市设为北京，默认：“全国”
				});

				function geoCode() {
					var address = that.details.address;
					geocoder.getLocation(address, function (status, result) {
						// console.log(status, result)
						if (status === 'complete' && result.geocodes.length) {
							var lnglat = result.geocodes[0].location
							// console.log(lnglat)
							that.lat = lnglat.lat // 经度
							that.lon = lnglat.lng
							var map = new AMap.Map('container', {
								resizeEnable: true, //是否监控地图容器尺寸变化
								zoom: 15, //初始化地图层级
								center: [that.lon, that.lat] //初始化地图中心点
							});

							// 创建一个 Icon
							var startIcon = new AMap.Icon({
								// 图标尺寸
								size: new AMap.Size(25, 34),
								// 图标的取图地址
								image: that.location,
								// 图标所用图片大小
								imageSize: new AMap.Size(25, 32),
								// 图标取图偏移量
								imageOffset: new AMap.Pixel(-9, -3)
							});


							// 将 icon 传入 marker
							var startMarker = new AMap.Marker({
								position: new AMap.LngLat(that.lon, that.lat),
								icon: startIcon,
								offset: new AMap.Pixel(-13, -30)
							});
							// 将 markers 添加到地图
							map.add([startMarker]);
						} else {
							that.$message({
								message: '根据地址查询位置失败',
								type: 'warning'
							})
						}
					});
				}
			},
			closeAmap() {
				document.documentElement.style.overflow = "visible";
				document.documentElement.style.height = "100%";
				document.body.style.overflow = "visible";
				document.body.style.height = "100%";
				this.isOpenAmap = false
			},
			checkNotice() {
				check_notice({
					goods_id: this.detailsId,
					token: this.token
				}).then(res => {
					// console.log(res)
					this.isNOtice = res.data.is_notice
					// this.$notify({
					// 	title: res.message,
					// 	type: 'success'
					// });
				}).catch(error => {
					// this.$notify({
					// 	message: error.message,
					// 	type: "error"
					// });
					if (error.code === -101) {
						this.$router.push({name: 'login'})
					}
				})
			},
			// 订阅提醒
			noticChg() {
				notice_chg({
					goods_id: this.detailsId,
					token: this.token
				}).then(res => {
					// console.log(res)
					this.$notify({
						title: res.message,
						type: 'success'
					});
					this.checkNotice()
				}).catch(error => {
					this.$notify({
						message: error.message,
						type: "error"
					});
					if (error.code === -101) {
						this.$router.push({name: 'login'})
					}
				})
			},
			toShowVR() {
				this.ShowVR = true
				// this.VRUrl = 'https://720yun.com/t/09vkOeq75i7?scene_id=51981427'
				this.VRUrl = this.details.url_vr
			},
			closeVR() {
				this.ShowVR = false
				this.VRUrl = ''
			},
			toShowVideo() {
				this.ShowVideo = true
				// this.VRUrl = 'https://www.anjuke.com/pc/esf/vrview/?token=QGyqP1kaRoKLqZVNdFByikreBGSu9CiRKmraN3OS92SSi7O%2FWZr0HmRrG1Ar2F0A&app_id=10002&city_id=13&from=singlemessage&isappinstalled=0'
				// this.videoUrl = 'http://tbm-auth.alicdn.com/iX5vZlQ8aHtyCHbawIi/LKU1prC4XN4AFgAa02M_220040138238_hd_hq.mp4?auth_key=1592360755-0-0-9b00d2feebb380420994bf9ef02dea7d'
				// this.videoUrl = 'https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm'
				this.videoUrl = 'http://' + this.details.url_video.split('//')[1]
				// this.videoUrl = this.details.url_video
              // console.log(this.videoUrl)
			},
			closeVideo() {
				this.ShowVideo = false
				this.videoUrl = ''
			},
			// 竞拍记录列表首行样式
			firstRowClass({rowIndex}) {
				if (rowIndex === 0 && this.page === 1) {
					this.rowIndex = rowIndex
					return 'recordActive'
				} else {
					return ''
				}
			},
			// 立即出价
			toShowApply() {
				const that = this
				const price = parseInt(this.price.replace(/,/gi, ''))
				const price_cur = parseInt(this.details.price_cur.replace(/,/gi, ''))
				const price_inc = parseInt(this.details.price_inc.replace(/,/gi, ''))
				// console.log(this.details.price_cur.replace(/,/gi, ''))
				let spread_price = price - price_cur
				let remainder = spread_price % price_inc // 余数
				// console.log(price,price_inc,spread_price,remainder)
				if (spread_price < 0) {
					this.$message({
						message: "输入价格必须高于当前价",
						type: "warning"
					});
				} else if (remainder !== 0) {
					let message = "加价必须是加价幅度" + this.details.price_inc + "的整数倍"
					this.$message({
						message: message,
						type: "warning"
					});
				} else {
					const loading = this.$loading({
						lock: true,
						text: '正在提交！',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					commitRecord({
						price: price,
						goods_id: this.detailsId,
						token: this.token
					}).then(res => {
						// console.log(res)

						setTimeout(() => {
							that.detail()
							that.recordInfo()
							loading.close();
							this.$notify({
								title: res.message,
								type: 'success'
							});
						}, 1500);

					}).catch(error => {
						setTimeout(() => {
							loading.close();
							that.detail()
							that.recordInfo()
							this.$message({
								message: error.message,
								type: "error"
							});
						}, 1500);

					})
				}
			},
			// 详情
			detail() {
				let that = this
				goodsDetail({
					// id: localStorage.getItem('auctionId')
					id: this.detailsId
				}).then(res => {
					// console.log(res)
					const type = this.category_type === 0 ? "竞拍" : "竞租"
					this.details = res.data
					this.content = res.data.tips
					this.time_delay_tip = "如果在" + type + "结束前" + res.data.time_delay + "分钟出价，" + type + "结束时间会在出价时间基础上延长" + res.data.time_delay + "分钟，直至无人出价，" + type + "结束。"
					// console.log(this.time_delay_tip)
					if (res.data.price_cur === res.data.price_start) {
						this.isEndPrice = true
					} else {
						this.isEndPrice = false
					}
					// this.toThousands(res.data.price_cur)
					// 添加千位分隔符
					this.details.number_view = parseInt(res.data.number_view).toLocaleString()
					this.details.number_join = parseInt(res.data.number_join).toLocaleString()
					this.details.price_cur = parseInt(res.data.price_cur).toLocaleString()
					this.details.price_start = parseInt(res.data.price_start).toLocaleString()
					this.details.price_guess = parseInt(res.data.price_guess).toLocaleString()
					this.details.price_hold = parseInt(res.data.price_hold).toLocaleString()
					this.details.price_inc = parseInt(res.data.price_inc).toLocaleString()
					this.details.price_min = parseInt(res.data.price_min).toLocaleString()
					this.details.price_max = parseInt(res.data.price_max).toLocaleString()
					// console.log(this.details.price_cur.replace(/,/gi, ''))
					// const price_start = parseInt(this.details.price_start.replace(/,/gi, ''))
					const price_cur = parseInt(this.details.price_cur.replace(/,/gi, ''))
					const price_inc = parseInt(this.details.price_inc.replace(/,/gi, ''))
					// console.log(price_cur)

					if (price_cur === 0 || price_cur == null || price_cur === '' || res.data.user_id === '-') {
						this.price = this.details.price_start
						// } else if (price_cur === price_start) {
						// 	this.price = price_start.toLocaleString()
					} else {
						this.price = (price_cur + price_inc).toLocaleString()
					}
					if (res.data.pics != null) {
						this.pics = JSON.parse(res.data.pics)
					}
					this.$nextTick(() => {
						that.initSwiper()
						that.originMap()
						that.List()
						that.getFlow()
					});
				}).catch(error => {
					this.$message({
						message: error.message,
						type: "error"
					});
					if (error.code === 116) {
						this.$router.go(-1)
					}
				})
			},
			// 获取电话，提示内容
			getPhone() {
				about({}).then(res => {
					// console.log(res)
					// this.callPhone = res.data.phone
					this.notice = res.data.notice
				}).catch(error => {
					this.$message({
						message: error.message,
						type: "error"
					});
				})
			},
			// 点击切换选项
			changeTab(n) {
				this.tab = n
				if (n === 1) {
					this.content = this.details.tips
				} else if (n === 2) {
					this.content = this.details.notice
				} else if (n === 3) {
					this.content = this.details.readme
				} else if (n === 4) {
					this.content = this.details.content
				} else if (n === 6) {
					this.content = `<p style="text-align: center;"><img src="${this.details.imgUrlOfAuctionConfirm}" title="" alt=""/></p>`
				}
			},
			//	流程
			getFlow() {
				// console.log(this.categoryId)
				flows({
					category_id: this.details.category_id
					// localStorage.getItem('categoryId')
				}).then(res => {
					// console.log(res)
					this.flowList = res.data
				}).catch(error => {
					this.$message({
						message: error.message,
						type: 'error'
					})
				})
			},
			// 输入价格
			toInputPrice() {
				// console.log(this.price)
				if (this.price === '') {
					this.price = '0'
				}
				this.price = this.price.replace(/[^\d]/g, '')
				this.price = parseInt(this.price).toLocaleString()
				// console.log(this.price)
			},
			// 加
			toAdd() {
				// console.log(this.price)
				if (this.price === '') {
					const price_cur = parseInt(this.details.price_cur.replace(/,/gi, ''))
					const price_inc = parseInt(this.details.price_inc.replace(/,/gi, ''))
					// console.log(price, price_inc)
					this.price = (price_cur + price_inc).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
				} else {
					const price = parseInt(this.price.replace(/,/gi, ''))
					const price_cur = parseInt(this.details.price_cur.replace(/,/gi, ''))
					const price_inc = parseInt(this.details.price_inc.replace(/,/gi, ''))
					// console.log(price, price_inc)
					if (price < price_cur) {
						this.price = (price_cur + price_inc).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
					} else {
						this.price = (price + price_inc).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
					}
				}
			},
			// 减
			subtract() {
				if (this.price !== '') {
					const price_start = parseInt(this.details.price_start.replace(/,/gi, ''))
					let price = parseInt(this.price.replace(/,/gi, ''))
					const price_cur = parseInt(this.details.price_cur.replace(/,/gi, ''))
					const price_inc = parseInt(this.details.price_inc.replace(/,/gi, ''))
					let minPrice = 0
					if (this.details.user_id === '-') {
						minPrice = price_start
						// price = price + price_inc
					} else {
						minPrice = price_cur + price_inc
					}
					// console.log(price,price_cur, price_inc)
					// console.log(this.price)
					if (price < minPrice) {
						let message = '最少出价' + minPrice + '元'
						this.$message({
							message: message,
							type: 'warning'
						})
					} else {
						this.price = parseInt(price - price_inc).toLocaleString()
					}
				} else {
					this.$message({
						message: '您还没有输入价格',
						type: 'warning'
					})
				}
			},
			// 缩略图
			initSwiper() {
				// let _this = this
				//小图
				let galleryThumbs = new Swiper('.gallery-thumbs', {
					// direction : 'vertical',//控制滚动的方向，水平或垂直
					spaceBetween: 10,
					slidesPerView: 4,
					autoplay: {
						disableOnInteraction: false,
					},
				});
				//大图
				new Swiper('.gallery-top', {
					// spaceBetween: 0,
					// effect: 'fade',
					slidesPerView: 1,
					loop: true,
					// loopedSlides: 5, //looped slides should be the same
					// navigation: {
					// 	nextEl: '.left-arrow',
					// 	prevEl: '.right-arrow',
					// },
					autoplay: {
						disableOnInteraction: false,
					},
					// autoplayDisableOnInteraction: false,// 这样，即使我们滑动之后， 定时器也不会被清除
					// observer: true,   //监听
					thumbs: {
						swiper: galleryThumbs,
					},
				});
			},
			// 是否有效登录
			hasLogin() {
				// console.log(this.noLogin === '1')
				if (this.noLogin === '1') {
					this.getCheckPaiMai()
					this.recordInfo()
					this.checkNotice()
				}
			},
			// 竞拍记录
			List() {
				record({
					page: this.page,
					limit: this.limit,
					// goods_id: localStorage.getItem('auctionId')
					goods_id: this.detailsId,
				}).then(res => {
					// console.log(res)
					this.recordList = res.data.data
					this.total = res.data.total
				}).catch(error => {
					// console.log(error)
					this.$message({
						message: error.message,
						type: 'warning'
					})
				})
			},
			// 我的出价信息
			recordInfo() {
				record_info({
					// goods_id: localStorage.getItem('auctionId'),
					goods_id: this.detailsId,
					token: this.token
				}).then(res => {
					// console.log(res)
					if (res.code === 0) {
						this.myRecordInfo = res.data
					} else if (res.code === -101) {
						this.noLogin = '0'
					}
				}).catch(error => {
					this.$message({
						message: error.message,
						timeout: 2000,
					});
				})
			}
			,

			// 拍卖权限
			getCheckPaiMai() {
				checkPaimai({
					goods_id: this.detailsId,
					// goods_id: localStorage.getItem('auctionId'),
					token: this.token
				}).then(res => {
					// console.log(res)
					if (res.code === 0) {
						if (res.data.is_paimai === 0) {
							this.needApply = true
						} else if (res.data.is_paimai === 1) {
							this.tobin = true
						}
					} else if (res.code === -101) {
						this.noLogin = '0'
						// this.$router.push("/login");
					}
				}).catch(error => {
					// console.log(error)
					if (error.code === 101) {
						this.needApply = true
					} else {
						// console.log(error)

					}
				})
			}
			,
			handleCurrentChange(val) {
				this.page = val
				this.List()
			}
			,
		}
		,
		//离开当前页面后执行浏览上报
		destroyed() {
			clearInterval(this.timer)
			viewReport({
				id: this.detailsId,
				// id: localStorage.getItem('auctionId')
			}).then(res => {
				console.log(res)
			})
		}
		,
	}
</script>

<style lang="less" rel="stylesheet/less" scoped>
    @import "auctionDetail";
</style>